package com.ilussobsa.views.dialogs

import com.ilussobsa.Strings
import com.ilussobsa.Vehicle
import com.ilussobsa.views.sellingLotShortDetails
import com.lightningkite.kiteui.*
import com.lightningkite.kiteui.QueryParameter
import com.lightningkite.kiteui.models.Align
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.navigation.KiteUiScreen
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.report
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.lightningdb.Condition
import com.lightningkite.lightningdb.Query
import com.lightningkite.lightningdb.condition


class AddMakes(val items: Map<String, List<String>>, val isMakes: Boolean) : KiteUiScreen {

    @QueryParameter("makes")
    val makeString = Property<Set<String>>(emptySet())
    val makeSearch = Property<String>("")
    override fun ViewWriter.render() {
        dismissBackground {
//            val test = shared {
//                Query (
//                    condition<Vehicle> {
//                        Condition.And(
//                            listOfNotNull(
//                                makeSearch.debounce(500L).await().takeUnless { it.isBlank() }
//                                    ?.let { Condition.FullTextSearch(it, true) },
//                                condition(true)
//                            )
//                        )
//                    },
//                    limit = 500
//                )
//            }
            reactiveScope {
                if (makeSearch().isNotEmpty() && isMakes) items.forEach { it -> }


            }
            ignoreInteraction = true
            centered - card - col {
                centered - h2 {
                    ::content{
                        if (isMakes) Strings.addMakes else Strings.addModels
                    }
                }
                fieldTheme - textField {
                    hint = Strings.search
                    content bind makeSearch
                }
                scrolls - sizeConstraints(
                    width = 15.rem,
                    height = 20.rem
                ) - col {
                    if (isMakes) {

                        items.forEach { it ->
                            toggleButton {
                                row {
                                    weight(2f) - col {
                                        gravity(Align.Start, Align.Center) - text {
                                            ::content { it.key }
                                        }
                                    }

                                    weight(1f) - col {
                                        gravity(Align.End, Align.Center) - subtext {
                                            ::content{ it.value.size.toString() }
                                        }
                                    }

                                }

                            }
                        }
                    } else {
                        items.forEach { it ->
                            it.value.forEach { it ->
                                toggleButton {
                                    row {
                                        weight(2f) - col {
//                                            it.forEach { v ->
//
                                            gravity(Align.Start, Align.Center) - text {
                                                ::content { it }

                                            }
//                                            }

                                        }
                                        weight(1f) - col {
                                            gravity(Align.End, Align.Center) - subtext {
                                                ::content{ "5" }
                                            }
                                        }

                                    }

                                }
                            }

                        }
                    }


                }
                gravity(Align.Center, Align.Center) - row {
                    button {
                        h6(Strings.cancel)
                        onClick {
                            navigator.dismiss()
                        }
                    }
                    important - button {
                        h6(Strings.done)
                        onClick {
                            try {
//                                    currentSession().dealership.removeUserFromDealership(
//                                        dealership.awaitNotNull()._id,
//                                        user.awaitNotNull().email
//                                    )
                                navigator.dismiss()
                            } catch (e: Exception) {
                                e.report()
                                alert(
                                    Strings.error,
                                    Strings.thereWasAnErrorUpdatingThisSearch
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}